import { cn } from "@/lib/utils.ts";
import { Loading } from "./loading";
import { TableBody, TableCell, TableRow } from "./table";

interface SkeletonTableBodyProps {
  colSpan?: number;
  className?: string;
}

function SkeletonTableBody({ colSpan = 1, className }: SkeletonTableBodyProps) {
  return (
    <TableBody>
      <TableRow>
        <TableCell colSpan={colSpan}>
          <Loading className={className} />
        </TableCell>
      </TableRow>
    </TableBody>
  );
}

interface SkeletonBaseProps {
  width: number;
  height: number;
  className?: string;
}

function SkeletonBase({ width, height, className }: SkeletonBaseProps) {
  const style: React.CSSProperties = {
    width: width,
    height: height,
  };
  return <div className={cn("animate-pulse rounded-md bg-primary/10", className)} style={style} />;
}

export const Skeleton = {
  TableBoday: SkeletonTableBody,
  Base: SkeletonBase,
};
